<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import DevicePixelRatio from "./assets/js/devicePixelRatio.js";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  created() {
    new DevicePixelRatio().init();
  },
};
</script>

<style>
@import "./assets/css/base.css";
@import "./styles/public.css";
#app {
  width: 100%;
  height: 100%;
}
.speed-box .el-progress__text {
  color: #fff;
}
/*.permission-dialog-tree-first*/
/*  > .el-tree-node*/
/*  > .el-tree-node__content*/
/*  > .el-checkbox {*/
/*  display: none;*/
/*}*/
#li-share .el-input__icon {
  line-height: 34px;
}
#information-main .main-left .el-submenu__title:hover {
  background: none !important;
}
.progress-bar .progress-bar-content .el-progress__text {
  color: #fff !important;
}
#reset-password .el-form-item__content {
  line-height: inherit !important;
}
#reset-password .el-input__inner {
  height: 40px;
}
#reset-password .el-form-item__error {
  top: 110%;
}
#register-user-body .el-form-item__content {
  line-height: inherit !important;
}
#register-user-body .el-form-item__content .el-form-item__error {
  top: 84% !important;
  line-height: inherit !important;
  padding-top: 0px;
}
#register-user-body .code .el-form-item__error {
  top: 105% !important;
}
.permission-dialog-tree-first
  > .el-tree-node
  > .el-tree-node__children
  .el-tree-node__expand-icon {
  opacity: 0;
}
#inbox-time-query .el-input__icon {
  line-height: 27px;
}
#inbox-time-query .el-range-separator {
  line-height: 26px;
}
.view-reply .el-dialog__title {
  font-size: 16px;
}
.view-reply .el-dialog__header {
  padding: 0px !important;
}
.view-reply .el-dialog__body {
  padding: 0px !important;
}
.father .el-progress-bar {
  padding-right: 70px;
}
.father .el-progress__text {
  margin-left: 0;
}
.l-n-l .el-submenu__title:hover {
  background: rgb(0, 150, 136) !important;
}
#new-integrate-tree .el-tree-node > .el-tree-node__children {
  overflow: visible;
}
/*.document-management .el-table .el-table__cell{*/
/*  padding: 8px 0px;*/
/*}*/
.el-table .el-table__cell {
  padding: 8px 0px;
}
.compar .DisableSelection > .cell {
  display: none !important;
}
.comslider .el-tree-node > .el-tree-node__children {
  overflow: inherit !important;
}
#add-view-model .el-form-item {
  margin-bottom: 0px;
}
#share-video .el-dialog {
  padding: 0px !important;
}
#problem-feedback img {
  max-width: 800px;
}
.o-s-object-classification .el-table .el-table__cell {
  padding: 0px;
}
.o-s-object-classification-tabel
  .el-table
  .el-table__header-wrapper
  .el-table__cell {
  padding: 10px 0px;
}
.decompositionStructure .el-cascader-menu__wrap {
  height: auto;
  min-height: 204px;
  max-height: 400px;
}
.bf-loading .bf-loading-gif {
  width: 111px !important;
  height: 32px !important;
  display: block;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 1001;
  background-image: url("../static/viewModel/images/loading.gif") !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue